import { request } from '../http';

export const switchUserOrganization = (data) => request('/api/user-context/organization', { method: 'post', data });

export const switchUserRole = (data) => request('/api/user-context/role', { method: 'post', data });
